import React from "react";
import ReactDOM from "react-dom/client"; // ✅ new import
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import { store, persistor } from "./app/store";
import { PersistGate } from "redux-persist/integration/react";
import { UserProvider } from "./context/UserContext";

// ✅ get root container
const container = document.getElementById("root");

// ✅ create root
const root = ReactDOM.createRoot(container);

// ✅ render with concurrent features
root.render(
    <React.StrictMode>
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <UserProvider>
                    <App />
                </UserProvider>
            </PersistGate>
        </Provider>
    </React.StrictMode>
);
